/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Scope_Detail5Inputs */

const en_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data sources, page types and ranking targets.`)
};

const ar_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مصادر البيانات وأنواع الصفحات وأهداف الترتيب.`)
};

const bn_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেটা উৎস, পৃষ্ঠার ধরন আর র‍্যাঙ্কিং লক্ষ্য।`)
};

const de_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenquellen, Seitentypen und Ranking-Ziele.`)
};

const es_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes de datos, tipos de página y objetivos de posicionamiento.`)
};

const fr_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources de données, types de pages et objectifs de classement.`)
};

const pt_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes de dados, tipos de página e metas de posição.`)
};

const zh_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确数据源、页面类型和排名目标。`)
};

const tr_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri kaynakları, sayfa tipleri ve sıralama hedefleri.`)
};

const ru_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источники данных, типы страниц и цели ранжирования.`)
};

const pl_svc_programmatic_seo_scope_detail5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródła danych, typy stron i cele rankingowe.`)
};

/**
* | output |
* | --- |
* | "Data sources, page types and ranking targets." |
*
* @param {Svc_Programmatic_Seo_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_scope_detail5 = /** @type {((inputs?: Svc_Programmatic_Seo_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "de") return de_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "es") return es_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_scope_detail5(inputs)
	return en_svc_programmatic_seo_scope_detail5(inputs)
});
export { svc_programmatic_seo_scope_detail5 as "svc_programmatic-seo_SCOPE_detail" }